import { Component } from 'react';
import classNames from 'classnames/bind';
import { Dropdown } from 'react-bootstrap';
import autoBind from 'react-autobind';
import { isMobileOnly } from 'react-device-detect';

import DropdownFilters from './DropdownFilters';
import withComponentName from '../../../decorators/withComponentName';

import { otherFilters } from '../../../data/filters/storyFilters';
import { capitalize } from '../../../helpers/capitalize';
import { updateUserNewsFeedView } from '../../../helpers/storyFilterHelpers';

import Styles from '../story-filters-styles.module.scss';
import FilterButtonInfo from '../StoryFiltersButton/FilterButtonInfo';
import FiltersMobileModal from '../FiltersMobileModal';

import StorageSvc from '../../../services/StorageSvc';

const cx = classNames.bind(Styles);

export class OtherFilter extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      openFilterModal: false,
      dropdown: {
        open: false,
      },
    };
    this.restoreState();
  }

  handleCloseModal() {
    this.setState({ openFilterModal: false });
  }

  onExpandStories(status) {
    const {
      actions,
      piwikEnabled,
      token,
      freezeStories,
    } = this.props;

    freezeStories(false);
    actions.toggleExpandStories(status, token);
    StorageSvc.setItem(
      'expandStories',
      JSON.stringify({ status }),
    );

    if (piwikEnabled) {
      _paq.push(
        status ? (
          ['trackEvent', 'Filters', 'Expand all stories ON']
        ) : (
          ['trackEvent', 'Filters', 'Expand all stories OFF']
        ),
      );
    }
  }

  onUserNewsfeedViewImages(status) {
    const {
      actions,
      piwikEnabled,
      token,
      freezeStories,
    } = this.props;

    freezeStories(false);
    actions.toggleUserNewsfeedViewImages(status, token);
    StorageSvc.setItem(
      'userNewsfeedViewImages',
      JSON.stringify({ status }),
    );

    if (piwikEnabled) {
      _paq.push(
        status ? (
          ['trackEvent', 'Filters', 'Show images ON']
        ) : (
          ['trackEvent', 'Filters', 'Show images OFF']
        ),
      );
    }
  }

  onUserNewsfeedViewDescription(status) {
    const {
      actions,
      piwikEnabled,
      token,
      freezeStories,
    } = this.props;

    freezeStories(false);
    actions.toggleUserNewsfeedViewDescription(status, token);
    StorageSvc.setItem(
      'userNewsfeedViewDescription',
      JSON.stringify({ status }),
    );

    if (piwikEnabled) {
      _paq.push(
        status ? (
          ['trackEvent', 'Filters', 'Show Description ON']
        ) : (
          ['trackEvent', 'Filters', 'Show Description OFF']
        ),
      );
    }
  }

  onShowSummarisation(status) {
    const {
      actions,
      piwikEnabled,
      token,
      freezeStories,
    } = this.props;

    freezeStories(false);
    actions.toggleSummarisation(status, token);

    if (piwikEnabled) {
      _paq.push(
        status ? (
          ['trackEvent', 'Filters', 'Key Headlines ON']
        ) : (
          ['trackEvent', 'Filters', 'Key Headlines OFF']
        ),
      );
    }
  }

  onUserNewsfeedView(status) {
    const {
      actions,
      piwikEnabled,
      token,
      freezeStories,
    } = this.props;

    freezeStories(false);
    updateUserNewsFeedView({
      status,
      actions,
      token,
    });

    if (piwikEnabled) {
      _paq.push(
        status ? (
          ['trackEvent', 'Filters', `${capitalize(status)} view ON`]
        ) : (
          ['trackEvent', 'Filters', `${capitalize(status)} view OFF`]
        ),
      );
    }
  }

  onGroupSimilars(status) {
    const {
      actions,
      piwikEnabled,
      token,
      freezeStories,
    } = this.props;

    freezeStories(false);
    actions.toggleGroupSimilars(status, token);
    StorageSvc.setItem(
      'groupSimilars',
      JSON.stringify({ status }),
    );

    if (!status) {
      this.onShowSimilars(false);
    }

    if (piwikEnabled) {
      _paq.push(
        status ? (
          ['trackEvent', 'Filters', 'Group similar stories ON']
        ) : (
          ['trackEvent', 'Filters', 'Group similar stories OFF']
        ),
      );
    }
  }

  onShowSimilars(status) {
    const {
      actions,
      piwikEnabled,
      token,
      freezeStories,
    } = this.props;

    freezeStories(false);
    actions.toggleShowSimilars(status, token);
    StorageSvc.setItem(
      'showSimilars',
      JSON.stringify({ status }),
    );

    if (piwikEnabled) {
      _paq.push(
        status ? (
          ['trackEvent', 'Filters', 'Show similar stories in feed ON']
        ) : (
          ['trackEvent', 'Filters', 'Show similar stories in feed OFF']
        ),
      );
    }
  }

  onTogglePremiumLabels(status) {
    const {
      actions,
      freezeStories,
    } = this.props;

    freezeStories(false);
    actions.togglePremiumLabels(status);
    StorageSvc.setItem(
      'showPremiumLabels',
      JSON.stringify({ status }),
    );
  }

  restoreState() {
    const { token, actions } = this.props;

    if (token) return;

    const expandStoriesCache = JSON.parse(StorageSvc.getItem('expandStories')) || {};
    const userNewsfeedViewImagesCache = JSON.parse(StorageSvc.getItem('userNewsfeedViewImages')) || {};
    const userNewsfeedViewDescriptionCache = JSON.parse(StorageSvc.getItem('userNewsfeedViewDescription')) || {};
    const groupSimilarsCache = JSON.parse(StorageSvc.getItem('groupSimilars')) || {};
    const showSimilarsCache = JSON.parse(StorageSvc.getItem('showSimilars')) || {};
    const showRowsCache = JSON.parse(StorageSvc.getItem('userNewsfeedView')) || {};
    const showSimpleCache = StorageSvc.getItem('userSimplifiedView') || false;
    const userNewsfeedViewCompactCache = JSON.parse(StorageSvc.getItem('userNewsfeedViewCompact')) || {};
    const isPremiumLabelsEnabledCache = JSON.parse(StorageSvc.getItem('showPremiumLabels')) || { status: true };
    if ('status' in userNewsfeedViewImagesCache) actions.toggleUserNewsfeedViewImages(JSON.parse(userNewsfeedViewImagesCache.status), null);
    if ('status' in userNewsfeedViewDescriptionCache) actions.toggleUserNewsfeedViewDescription(JSON.parse(userNewsfeedViewDescriptionCache.status), null);
    if ('status' in expandStoriesCache) actions.toggleExpandStories(JSON.parse(expandStoriesCache.status), null);
    if ('status' in groupSimilarsCache) actions.toggleGroupSimilars(JSON.parse(groupSimilarsCache.status), null);
    if ('status' in showSimilarsCache) actions.toggleShowSimilars(JSON.parse(showSimilarsCache.status), null);
    if ('status' in showRowsCache) actions.toggleUserNewsfeedView(showRowsCache.status, null);
    if (JSON.parse(showSimpleCache)) {
      actions.toggleUserSimplifiedView(JSON.parse(showSimpleCache), null);
    }
    if ('status' in userNewsfeedViewCompactCache) actions.toggleUserNewsfeedViewCompact(userNewsfeedViewCompactCache.status, null);
    if ('status' in isPremiumLabelsEnabledCache) {
      actions.togglePremiumLabels(JSON.parse(isPremiumLabelsEnabledCache.status));
    }
  }

  toggleDropdown(status) {
    const { width } = this.props;

    if (width <= 1024) return this.openFilterModal();

    this.setState({
      dropdown: {
        open: status,
      },
    }, () => {
      const { freezeStories } = this.props;
      freezeStories(status);
    });
  }

  openFilterModal() {
    const { openFilterModal } = this.state;

    this.setState({ openFilterModal: !openFilterModal });
  }

  render() {
    const {
      rbi,
      dropdownTitle,
      width,
      filterValues,
      onSimplifiedViewTabsClick,
      hasBigScreenDesign,
      isSimpleLayout,
      bookmarksPage,
    } = this.props;
    const { dropdown, openFilterModal } = this.state;

    return (
      <Dropdown
        show={dropdown.open}
        id={cx('other-dropdown')}
        onToggle={this.toggleDropdown}
        className={cx('story-filters_btn', { rbi, big_screen: hasBigScreenDesign })}
      >
        <Dropdown.Toggle>
          <FilterButtonInfo
            dropdownTitle={dropdownTitle}
            openFilter={dropdown.open}
            width={width}
            selectedValue={
              (
                otherFilters
                  .filter(({ key }) => filterValues[key])
                  .map(({ value }) => value)
                  .join(', ')
                || 'None'
              )
            }
            rbi={rbi}
          />
        </Dropdown.Toggle>
        {width >= 1025 ? (
          <Dropdown.Menu
            rootCloseEvent="click"
            show={dropdown.open}
            flip={false}
            bsPrefix="dropdown-menu"
          >
            <FilterInner
              onGroupSimilars={this.onGroupSimilars}
              dropdownTitle={dropdownTitle}
              filterValues={filterValues}
              onExpandStories={this.onExpandStories}
              onShowSimilars={this.onShowSimilars}
              onUserNewsfeedViewImages={this.onUserNewsfeedViewImages}
              onUserNewsfeedViewDescription={this.onUserNewsfeedViewDescription}
              onStoryPreview={this.onStoryPreview}
              onUserNewsfeedView={this.onUserNewsfeedView}
              onShowSummarisation={this.onShowSummarisation}
              rbi={rbi}
              onSimplifiedViewTabsClick={onSimplifiedViewTabsClick}
              hasBigScreenDesign={hasBigScreenDesign}
              isSimpleLayout={isSimpleLayout}
              width={width}
              onTogglePremiumLabels={this.onTogglePremiumLabels}
              bookmarksPage={bookmarksPage}
            />
          </Dropdown.Menu>
        ) : (
          <FiltersMobileModal
            openFilter={openFilterModal}
            handleCloseModal={this.handleCloseModal}
            showCloseIcon
            allowScrolling
          >
            <FilterInner
              onGroupSimilars={this.onGroupSimilars}
              dropdownTitle={dropdownTitle}
              filterValues={filterValues}
              onExpandStories={this.onExpandStories}
              onShowSimilars={this.onShowSimilars}
              onUserNewsfeedViewImages={this.onUserNewsfeedViewImages}
              onUserNewsfeedViewDescription={this.onUserNewsfeedViewDescription}
              onStoryPreview={this.onStoryPreview}
              onUserNewsfeedView={this.onUserNewsfeedView}
              onShowSummarisation={this.onShowSummarisation}
              rbi={rbi}
              onSimplifiedViewTabsClick={onSimplifiedViewTabsClick}
              isSimpleLayout={isSimpleLayout}
              width={width}
              onTogglePremiumLabels={this.onTogglePremiumLabels}
              bookmarksPage={bookmarksPage}
            />
          </FiltersMobileModal>
        )}
      </Dropdown>
    );
  }
}

const FilterInner = ({
  onGroupSimilars,
  dropdownTitle,
  filterValues,
  onExpandStories,
  onShowSimilars,
  onUserNewsfeedViewImages,
  onUserNewsfeedViewDescription,
  onStoryPreview,
  onUserNewsfeedView,
  onShowSummarisation,
  rbi,
  onSimplifiedViewTabsClick,
  hasBigScreenDesign,
  isSimpleLayout,
  onTogglePremiumLabels,
  bookmarksPage,
}) => (
  <div className={cx('dropdown-items-wrapper')}>
    <span className={cx('dropdown_title')}>
      {dropdownTitle}
      :
    </span>
    <div className={cx('other-filter__container', { rbi })}>
      <DropdownFilters
        userNewsfeedViewImages={filterValues.user_newsfeed_view_images_web}
        userNewsfeedViewDescription={filterValues.user_newsfeed_view_description_web}
        storyPreview={filterValues.story_preview}
        userNewsfeedView={filterValues[isMobileOnly ? 'user_newsfeed_view' : 'user_newsfeed_view_web']}
        expandStories={filterValues.expand_stories}
        groupSimilars={filterValues.group_similar_stories}
        showSimilars={filterValues.show_similar_stories_in_feed}
        summarisationEnabled={filterValues.summarization_enabled}
        userNewsfeedViewCompact={filterValues[isMobileOnly ? 'user_newsfeed_compactview' : 'user_newsfeed_compactview_web']}
        onExpandStories={onExpandStories}
        onGroupSimilars={onGroupSimilars}
        onShowSimilars={onShowSimilars}
        onUserNewsfeedViewImages={onUserNewsfeedViewImages}
        onUserNewsfeedViewDescription={onUserNewsfeedViewDescription}
        onStoryPreview={onStoryPreview}
        onUserNewsfeedView={onUserNewsfeedView}
        onShowSummarisation={onShowSummarisation}
        rbi={rbi}
        onSimplifiedViewTabsClick={onSimplifiedViewTabsClick}
        hasBigScreenDesign={hasBigScreenDesign}
        isSimpleLayout={isSimpleLayout}
        isPremiumLabelsEnabled={filterValues.isPremiumLabelsEnabled}
        onTogglePremiumLabels={onTogglePremiumLabels}
        playVideoButton
        bookmarksPage={bookmarksPage}
      />
    </div>
  </div>
);

export default withComponentName(OtherFilter);
